"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const v4_1 = require("zod/v4");
// be sure to updated expectedFiles in valley-bank-utils when adding input files
// specifically for "isValleyFile" typeguard
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    vanCust: v4_1.z.string(),
    vanCustAcctRel: v4_1.z.string(),
    vanDepAcct: v4_1.z.string(),
    loanCustRel: v4_1.z.string(),
    cuoDeposit: v4_1.z.string(),
    collatCustRel: v4_1.z.string(),
    cuoCollat: v4_1.z.string(),
    psPlusPortfolio: v4_1.z.string(),
    psPlusAccount: v4_1.z.string(),
    psPlusSecDetail: v4_1.z.string(),
    psPlusSecMaster: v4_1.z.string(),
    vanCmmt: v4_1.z.string(),
    vanLoanAcct: v4_1.z.string(),
    vanProduct: v4_1.z.string(),
    vanList: v4_1.z.string(),
    cuoMaint: v4_1.z.string(),
    cuoLoan: v4_1.z.string(),
    bloombergMutualFund: v4_1.z.string(),
    derivativePath: v4_1.z.string().optional(),
});
exports.nodeType = 'file_valley_bank_ingest';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'valleyBankIngest';
//# sourceMappingURL=types.js.map